class WqCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-wq-carousel-track]');
    if (!this.track || this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.querySelector('[data-wq-carousel-prev]')?.addEventListener('click', () => this.move(-1));
    this.querySelector('[data-wq-carousel-next]')?.addEventListener('click', () => this.move(1));
    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.move(-1);
      if (event.key === 'ArrowRight') this.move(1);
    });
  }
  move(direction) {
    const slide = this.track.querySelector('.wq-carousel__slide');
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    this.track.scrollBy({ left: direction * ((slide?.getBoundingClientRect().width || this.track.clientWidth) + gap), behavior: 'smooth' });
  }
}
if (!customElements.get('wq-carousel')) customElements.define('wq-carousel', WqCarousel);

class WqAnnouncement extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.wq-announcement__item')];
    this.index = 0;
    this.querySelector('[data-wq-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-wq-next]')?.addEventListener('click', () => this.show(this.index + 1));
    if (this.dataset.autoplay === 'true' && this.items.length > 1) this.start();
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
  }
  show(index) {
    this.items[this.index]?.classList.remove('is-active');
    this.index = (index + this.items.length) % this.items.length;
    this.items[this.index]?.classList.add('is-active');
  }
  start() { this.stop(); if (this.dataset.autoplay === 'true' && this.items.length > 1) this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.speed || 5000)); }
  stop() { if (this.timer) clearInterval(this.timer); }
  disconnectedCallback() { this.stop(); }
}
if (!customElements.get('wq-announcement')) customElements.define('wq-announcement', WqAnnouncement);

